import { ServerData } from './serverData';

export class ServerModel {
  public Action: string;
  public LstServerSource: ServerData[];
  public LstServerDestination: ServerData[];
  public ServerSource: ServerData;
  public ServerDestination: ServerData;
  public IsModeProd: boolean;
  public UrlIntranet: string;
  
}


